import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ContractMessage } from '../../../../../types/ContractMessage';
import { VesselMessage } from '../../../../../types/VesselMessage';
import { updateContract } from '../../../../common/api/clients/contracts.api';
import { updateVessel } from '../../../../common/api/clients/vessel.api';
import { queries } from '../../../../common/api/queryKeys/queries';
import { getInitialContractFormValues, toContractPayload } from '../../../../contracts/form/contractForm.helpers';
import { toVesselUpdateRequest } from '../../utils/toVesselUpdateRequest';

interface ExcludeVesselFromContractParams {
    vessel: VesselMessage;
    contract: ContractMessage;
}

export const useExcludeVesselFromContract = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ vessel, contract }: ExcludeVesselFromContractParams) => {
            const excludedVesselIds = [...new Set([...(contract.excludedVesselIds ?? []), vessel.id])];

            await updateContract({
                id: contract.id,
                data: {
                    ...toContractPayload({
                        ...getInitialContractFormValues(contract),
                        excludedVesselIds,
                    }),
                    priceListActivationMode: contract.priceListActivationMode,
                },
            });

            if (vessel.defaultContractId === contract.id) {
                await updateVessel({
                    vesselId: vessel.id,
                    vessel: {
                        ...toVesselUpdateRequest(vessel),
                        defaultContractId: null,
                    },
                });
            }
        },
        onSuccess: async (_, { vessel }) => {
            await queryClient.invalidateQueries({ queryKey: queries.vessels.detail(vessel.id).queryKey });
            await queryClient.invalidateQueries({ queryKey: queries.contracts._def });
        },
    });
};
